import expLaboralApi from "../../api/Alumno/expLaboralApi";
import { message } from 'antd';

export default {
    getExpLaboralMe : async () => {
        const response = await expLaboralApi.getExpLaboralMe();
        if (!response.success) {
            message.error(response.message);
            response.data = [];
        }
        return response;
    },
    createExpLaboralMe : async (data) => {
        const response = await expLaboralApi.createExpLaboralMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    editExpLaboralMe : async (data) => {
        const response = await expLaboralApi.editExpLaboralMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    deleteExpLaboralMe : async (id) => {
        const response = await expLaboralApi.deleteExpLaboralMe(id);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    }
}